import defaultSettings from "@/settings";
import i18n from "@/lang";
import { getLanguage } from "@/lang/index";
var title = defaultSettings.title;
export default function getPageTitle(key, fullName) {
  var realTitle = getLanguage() === "en" ? "TMS" : getLanguage() === "zhtw" ? "Weforsys軟件開發平臺" : title;
  var hasKey = i18n.te("route.".concat(key));
  if (hasKey) {
    var pageName = i18n.t("route.".concat(key));
    return "".concat(pageName, " - ").concat(realTitle);
  }
  return fullName ? "".concat(fullName, " - ").concat(realTitle) : realTitle;
}